import {
  AfterViewInit,
  DestroyRef,
  Directive,
  inject,
  Input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { take } from 'rxjs';

/**
 *  @param {EditPermissionDirectiveData} editPermissions
 * Disables formGroup is permissions in the list are missing.
 */
@Directive({
  selector: '[editPermissions]',
})
export class FormEditPermissionsDirective implements AfterViewInit {
  private permissionsService = inject(UserRolesAndPermissionsService);

  @Input() editPermissions: EditPermissionDirectiveData;
  private destroyRef = inject(DestroyRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.checkAndTogglePermissions();
    });

    this.editPermissions.formGroup.statusChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.checkAndTogglePermissions();
      });
  }

  private checkAndTogglePermissions(): void {
    this.permissionsService
      .hasPermissions(this.editPermissions.permissions)
      .pipe(take(1))
      .subscribe(hasPermissions => {
        this.togglePermissions(hasPermissions);
      });
  }

  private togglePermissions(hasPermissions: boolean): void {
    if (!hasPermissions) {
      this.editPermissions.formGroup.disable({ emitEvent: false });
    }
  }
}

export interface EditPermissionDirectiveData {
  formGroup: FormGroup;
  permissions: RolesAndPermissions[];
}
